'use strict';

export default class{

	/*@ngInject*/
	constructor(tutorID, $http){
		this.$http = $http;
		this.tutorID = tutorID;
		this.rateTypes = ['B', '1', '2'];
		this.loadsRequired = 3;
		this.loaded = false;
	}

	$onInit(){
		this.$http.get('/api/tutors/' + this.tutorID).then(res => {
			this.tutor = res.data;
			this.lowerLoad();
		})

		this.$http.get('/api/students').then(res => {
			this.students = res.data.map(student => {
		      	student.fullName = student.nameFirst + ' ' + student.nameLast;
		      	return student;
		    })
			this.lowerLoad();
		})

		this.$http.get('/api/presets').then(res => {
			this.presets = res.data || [];
			this.lowerLoad();
		})
	}

	addStudent(student){
		this._presets.push({hours: 1, rateType: 'B', studentID: student.studentID, tutorID: this.tutor.tutorID});

		this.selected = null;
	}

	delete(preset){

		this._presets.splice(this._presets.indexOf(preset), 1);

		if(preset._id){
			this.$http.delete('/api/presets/' + preset._id)
		}
	}

	lowerLoad(){
      this.loadsRequired -= 1;
      if(this.loadsRequired === 0){
      	var temp = this.presets.filter(preset => preset.tutorID === this.tutor.tutorID);
      	this._presets =  temp.sort((a,b) => {
	      let aName = this.returnName(a.studentID).toUpperCase();
	      let bName = this.returnName(b.studentID).toUpperCase();

	      if(aName < bName){
	        return -1;
	      }

	      if(aName > bName){
	        return 1;
	      }

	      return 0;
	    })
      	this.loaded = true;
      }
    }

	returnName(studentID){
		const student = this.students.find(student => student.studentID === studentID);

		if(!student){
			return 'Inactive Student'
		}
		return `${student.nameFirst} ${student.nameLast}`
	}

	returnCRM(studentID){
		const student = this.students.find(student => student.studentID === studentID);
		if(!student){
			return 'Inactive Student'
		}
		return student.crmID || 'No CRM ID';
	}

	save(callback){
		var loadsRequired = this._presets.length;

		function lowerLoad(){
			loadsRequired -= 1;

			if(loadsRequired === 0){
				callback();
			}
		}

		console.log(this._presets);

		this._presets.forEach(preset => {
			if(preset._id){
				this.$http.put('/api/presets/' + preset._id, preset).then(res => lowerLoad()) 
			} else {
				this.$http.post('/api/presets', preset).then(res => lowerLoad())
			}
		})
	}
}


// WEBPACK FOOTER //
// ./client/app/modals/edit-presets/edit-presets.controller.js